import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const ApplicationSummaryContext = createContext({
  applicants: [],
  landlordRentalApplication: {},
  refetchApplication: noop,
  isApplicationDeclined: false,
});

export const ApplicationSummaryContextProvider = ({ children, value }) => (
  <ApplicationSummaryContext.Provider value={value}>{children}</ApplicationSummaryContext.Provider>
);

ApplicationSummaryContextProvider.propTypes = {
  value: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export const useApplicationSummaryContext = () => useContext(ApplicationSummaryContext);
